<template>
    <div class="AdminUsers">
      <UserHeaderMenu/>
        <div class="container mt-3">
          <h4 class="pb-2"><b>Felhasználói beállítások</b></h4>
          <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-4 h-100">
                    <h5 class="pb-2"><b>Felhasználói fiókok</b></h5>
                    <b-list-group-item v-for="item in usersData" :key="item.id">
                      <b-avatar v-b-modal.edit-user-modal button @click="showUserData(item.id)" variant="light" class="align-center pointer"></b-avatar>
                      <span v-b-modal.edit-user-modal @click="showUserData(item.id)" class="pointer">{{item.company_name}} ({{item.firstname}} {{item.lastname}})</span>
                      <span class="float-right"><b-icon icon="x-circle" class="mt-2 pointer" @click="deleteThisUser(item.id)"  variant="danger"></b-icon></span>
                      </b-list-group-item>
                  </div>
                  <div class="col-lg-8 pb-3 border-left-own">
                  <h5 class="pb-2 mt-4 mt-lg-0 mt-md-0"><b>Felhasználói fiók létrehozás</b></h5>
                  <b-form-group
                    id="input-group-1"
                    label="E-mail cím:"
                    description="Ezzel az e-mail címmel lesz lehetőség belépni az ügyfél oldalon"
                  >
                    <b-form-input
                      v-model="new_email"
                      type="email"
                      required
                      placeholder="Adj meg egy e-mail címet"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="input-group-1"
                    label="Felhasználóhoz tartozó cégek:"
                    description="(ctrl + bal click-el van lehetőség többet kijelölni)"
                  >
                  <b-form-select v-model="selected" :options="options" multiple :select-size="8"></b-form-select>
                  </b-form-group>
                  <b-form-group
                    label="Jelszó:"
                    description="Ezzel az jelszóval lesz lehetőség belépni az ügyfél oldalon"
                  >
                    <b-form-input
                      v-model="new_password"
                      type="password"
                      required
                      placeholder="Legalább 7 karakter hosszú jelszót válasszon"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Vezetéknév:"
                    description="Könnyebb azonosítás érdekében"
                  >
                    <b-form-input
                      v-model="new_firstname"
                      type="text"
                      required
                      placeholder="Írja be a felhasználó vezetéknevét"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Keresztnév:"
                    description="Könnyebb azonosítás érdekében"
                  >
                    <b-form-input
                      v-model="new_lastname"
                      type="text"
                      required
                      placeholder="Írja be a felhasználó keresztnevét"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Telefonszám:"
                    description="Könnyebb azonosítás érdekében"
                  >
                    <b-form-input
                      v-model="new_phone"
                      type="text"
                      required
                      placeholder="Írja be a felhasználó telefonszámát"
                    ></b-form-input>
                  </b-form-group>
                  <b-button @click="createAccount" :style="{'background':companyData.color, 'border':'none'}" size="sm">Létrehozás</b-button>
                  </div>    
                </div>
              </div>
          </div>
        </div>
        <SettingsModal/>
        <b-modal id="edit-user-modal" ok-title="Bezár" ok-only title="Adatok szerkesztése">
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Adatok" active><div>
            <div>
                <label>Vezetéknév</label>
                <b-input type="text" v-model="edit_lastname"></b-input>
                
                <label>Keresztnév</label>
                <b-input type="text" v-model="edit_firstname"></b-input>

                <label>E-mail cím</label>
                <b-input type="text" v-model="edit_email"></b-input>

                <label>Telefonszám</label>
                <b-input type="text" v-model="edit_phone"></b-input>
                 
                <b-form-group
                    id="input-group-1"
                    label="Felhasználóhoz tartozó cégek:"
                    description="(ctrl + bal click-el van lehetőség többet kijelölni)"
                  >
                  <b-form-select v-model="selected_companys" :options="options" multiple :select-size="8"></b-form-select>
                  </b-form-group>
                

                <b-button class="mt-2" v-on:click="updateUserData(edit_id)" :style="{'background':companyData.color , 'border': 'none'}" >Mentés</b-button>
            </div>
            </div>
          </b-tab>
          <b-tab title="Jelszó változtatás">
            <div>
              <b-form  @submit.stop.prevent>
                <label for="password-change">Új jelszó</label>
                <b-input type="password" v-model="edit_password"></b-input>
                <b-button class="mt-2" v-on:click="updatePassword(edit_id)" :style="{'background':companyData.color , 'border': 'none'}" variant="success">Mentés</b-button>
              </b-form>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
    </div>
</template>
<script>
import axios from 'axios'
import SettingsModal from '../components/SettingsModal.vue'
import UserHeaderMenu from '../components/UserHeaderMenu.vue'

export default {
  components: {
    SettingsModal,
    UserHeaderMenu
  },
  name: 'AdminUsers',
  mounted(){
    this.getCompanyData()
	this.getUserAllData()
	this.getAllCompany()
  },
  data() {
      return {
        edit_id:'',
        edit_email:'',
        edit_password:'',
        edit_lastname:'',
        edit_firstname:'',
		edit_phone:'',
		edit_company:'',
        new_email:'',
        new_password:'',
        new_lastname:'',
        new_firstname:'',
        new_phone:'',
		new_company:'',
        usersData:[

        ],
		selected_companys:[],
		selected:[

		],
		options: [
          { value: 'a', text: 'This is First option' },
          { value: 'b', text: 'Default Selected Option' },
          { value: 'c', text: 'This is another option' },
          { value: 'd', text: 'This one is disabled', disabled: true },
          { value: 'e', text: 'This is option e' },
          { value: 'f', text: 'This is option f' },
          { value: 'g', text: 'This is option g' }
        ],
        companyData:[

        ],
      }
    },
    computed: {
      rows() {
        return this.items.length
      }
    },
    methods:{
        updatePassword(id){
          if(this.edit_password == ""){
              this.$swal('Hiba történt', 'Kötelező megadni jelszót' ,'error')
          }else if(this.edit_password.length < 7){
              this.$swal('Hiba történt', 'Legalább 8 karakter hosszú jelszót kell megadnia' ,'error')
          }else{
            const params = new URLSearchParams();
              params.append('updateUserPassword', true);
              params.append('id', id);
              params.append('password', this.edit_password);
              params.append('user_id', this.$session.get('id'));
              axios({
                  method: 'post',
                  url: process.env.VUE_APP_ADMIN_API,
                  data:params
              }).then((response) => {
                  this.$swal('Jelszó frissítve', 'Mostmár újonnan megadott jelszavaddal lesz lehetőséged belépni' ,'success')
                  this.usersData = response.data
              })
          }
        },
        updateUserData(id){
          if(this.edit_email == "" || this.edit_phone == "" || this.edit_firstname == "" || this.edit_lastname == ""){
              this.$swal('Hiba történt', 'Minden mező kitöltése kötelező' ,'error')
          }else{
            const params = new URLSearchParams();
              params.append('updateUserData', true);
              params.append('id', id);
              params.append('email', this.edit_email);
              params.append('firstname', this.edit_firstname);
              params.append('lastname', this.edit_lastname);
              params.append('phone', this.edit_phone);
              params.append('user_id', this.$session.get('id'));
              params.append('company', this.selected_companys);
              axios({
                  method: 'post',
                  url: process.env.VUE_APP_ADMIN_API,
                  data:params
              }).then((response) => {
                  this.$swal('Adatok frissítve', 'A fiók most már az új adatokkal fog megjelenni' ,'success')
                  this.usersData = response.data
              })
          }
        },
		getAllCompany(){
			const params = new URLSearchParams();
            params.append('getAllCompany', true);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_ADMIN_API,
                data:params
            }).then((response) => {
				this.options = response.data
            })
		},
        getCompanyData(){
            const params = new URLSearchParams();
            params.append('getCompanyData', true);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_LOGIN_API,
                data:params
            }).then((response) => {
                this.companyData = response.data[0]
            })
        },
        createAccount(){
            if(this.new_email == "" || this.password == "" || this.new_phone == "" || this.new_firstname == "" || this.new_lastname == ""){
              this.$swal('Hiba történt', 'Minden mező kitöltése kötelező' ,'error')
            }else{
              const params = new URLSearchParams();
              params.append('createAccount', true);
              params.append('email', this.new_email);
              params.append('password', this.new_password);
              params.append('firstname', this.new_firstname);
              params.append('lastname', this.new_lastname);
              params.append('phone', this.new_phone);
              params.append('company_name', this.selected);
              params.append('user_id', this.$session.get('id'));
              axios({
                  method: 'post',
                  url: process.env.VUE_APP_ADMIN_API,
                  data:params
              }).then((response) => {
                  console.log(response.data)
                  this.usersData = response.data
                  this.$swal('Létrehozva', 'A fiók sikeresen létrehozva' ,'success')
              })
            }
        },
        getUserAllData(){
          const params = new URLSearchParams();
            params.append('getUserAllData', true);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_ADMIN_API,
                data:params
            }).then((response) => {
                this.usersData = response.data
            })
        },
        showUserData(id){
          const params = new URLSearchParams();
            params.append('getThisUserData', true);
            params.append('userID', id);
            axios({
                method: 'post',
                url: process.env.VUE_APP_ADMIN_API,
                data:params
            }).then((response) => {
                this.edit_email = response.data[0].email
                this.edit_lastname = response.data[0].lastname
                this.edit_firstname = response.data[0].firstname
                this.edit_phone = response.data[0].phone
				this.edit_id = response.data[0].id,
				this.edit_company = response.data[0].company_name
			})
			const params2 = new URLSearchParams();
            params2.append('getThisUserCompanys', true);
            params2.append('userID', id);
            axios({
                method: 'post',
                url: process.env.VUE_APP_ADMIN_API,
                data:params2
            }).then((response) => {
                this.selected_companys = response.data
			})
        },
        deleteThisUser(id){
          this.$swal({
          title: 'Biztosan törölni szeretnéd?',
          text: "Amennyiben törlöd már nem lesz lehetőség belépni a felhasználóval!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Törlés',
          cancelButtonText: 'Mégsem'
        }).then((result) => {
          if(result.value) {
            if (result.value) {
              const params = new URLSearchParams();
              params.append('deleteThisUser', true);
              params.append('userID', id);
              axios({
                  method: 'post',
                  url: process.env.VUE_APP_ADMIN_API,
                  data:params
              }).then((response) => {
                  this.usersData = response.data
              })
              this.$swal('Sikeresen törölve', 'Most már nem lehetséges belépni a fiókba', 'error')
            }
          }
          })
        },
    }
}
</script>
<style>
.bg-light-gray{
    background:#e5e5e5;
}
.color-modal{
  width:204px;
}
#color-modal___BV_modal_content_>.modal-body{
  padding:0px;
  display: block;
  margin:0 auto;
}
#color-modal___BV_modal_header_{
  display:none;
}
#color-modal___BV_modal_footer_{
  border: none;
  display:block;
  text-align: center;
}
#color-modal___BV_modal_content_{
  padding:0px;
  margin:0px;
  width:100%;
  background:none;
  border:none;
}
#color-modal___BV_modal_footer_ > button.btn.btn-primary{
  color:black;
  background:none;
  border:1px solid black;
  font-size:10pt;
}
.pointer{
  cursor: pointer;
}
.border-left-own{
  border-left: 1px solid #dee2e6;
}
@media only screen and (max-width : 550px) {
  .border-left-own{
    border-left: none !important;
  }
}
</style>
